import { memo } from 'react'

/** Shared spinner placeholder shown while an agent node is generating. */
export const RunningPlaceholder = memo(function RunningPlaceholder({
  message,
  fill = false,
}: {
  message: string
  fill?: boolean
}) {
  return (
    <div
      className={`w-full ${fill ? 'h-full' : 'aspect-video'} bg-surface-1/50 flex flex-col items-center justify-center px-4`}
    >
      <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      <span className="text-xxs text-text-muted mt-1.5 text-center">
        {message}
      </span>
    </div>
  )
})

RunningPlaceholder.displayName = 'RunningPlaceholder'
